<template lang="pug">
    .loaded-files.d-flex
        div(
            v-for="(file, index) in files"
            :key="index"
        )

            .d-flex.align-center
                span {{file.name ? file.name : file.fileName}}


</template>

<script>
export default {
    data: () => ({
        files: []
    }),

    props: {
        value: {
            required: false
        }
    },

    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(val) {
                this.files = val;
            }
        },

        files: {
            deep: true,
            handler(val) {
                this.$emit("input", val);
            }
        }
    }
};
</script>

<style lang="sass" scoped>
.loaded-files
    height: 35px
</style>
